import { render, staticRenderFns } from "./BxPagination.vue?vue&type=template&id=3da77295&"
import script from "./BxPagination.vue?vue&type=script&lang=js&"
export * from "./BxPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports